import {Component, Inject, OnInit} from '@angular/core';
import {Observable, Subscription,timer} from "rxjs";
import {map, take} from "rxjs/operators";
import {ClientService} from "../../Services/client.service";

@Component({
    selector: 'app-pop-up-confirmation',
    templateUrl: './pop-up-confirmation.component.html',
    styleUrls: ['./pop-up-confirmation.component.scss'],
    standalone: false
})
export class PopUpConfirmationComponent implements OnInit {

  isCount = true;
  timer: any;
  // time = 5;
  timer$?: Observable<number>;
  timerSub?: Subscription;
  constructor(
    private clientService: ClientService) {}

  ngOnInit() {
    this.countDown(0)
  }

  onNoClick(): void {
   // this.dialogRef.close();
  }

  confirmationMail() {
   // const payload=this.data.email;
  //  this.clientService.resetPasswordRequest(payload).subscribe();
  }

  countDown(time:number) {
    this.timer$ = timer(0, 1000).pipe(
      map((i) => {
        return time - i;
      }),
      take(time + 1)
      // finalize(() => console.log('DONE')),
      // share()
    );
    this.timerSub = this.timer$.subscribe();
  }
}
